import { useTranslation } from 'react-i18next';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/shadcn/tooltip';

import type { AnalysisPriority } from '../../types';

type Props = {
  priority: Maybe<AnalysisPriority>;
};

export default function AnalysisPriority({ priority }: Props) {
  const { t } = useTranslation();

  if (priority !== 'HIGH' && priority !== 'URGENT') return null;

  return (
    <Tooltip>
      <TooltipTrigger>
        <span className="flex size-5.5 items-center justify-center rounded bg-red-100 text-sm font-bold text-red-500 dark:bg-red-900/70 dark:text-red-400">
          {'!!'}
        </span>
      </TooltipTrigger>

      <TooltipContent>{t(`PRIORITY_${priority}`)}</TooltipContent>
    </Tooltip>
  );
}
